module.exports = __webpack_public_path__ + "static/38-1ec781261021d19187a8ae1a026807f9.png";